"use client";

import React from "react";
import { Check, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "HVAC SYSTEMS",
  description: "Full evaluation of heating, cooling, and ventilation units to ensure peak seasonal efficiency and operational safety."
}, {
  title: "ROOFING & STRUCTURE",
  description: "Detailed assessment of shingles, flashing, gutters, and the integrity of the building's skeletal frame and support."
}, {
  title: "ELECTRICAL & PLUMBING",
  description: "Rigorous inspection of panels, wiring, pipes, and fixtures to identify potential hazards, leaks, or code violations."
}, {
  title: "EXTERIOR & FOUNDATION",
  description: "Examination of siding, grading, and foundation walls for signs of moisture intrusion or structural shifts."
}];
function FeatureItem({
  feature,
  index
}: {
  feature: {
    title: string;
    description: string;
  };
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <div data-section-id="150296" ref={ref} data-index={index} className={`flex items-start gap-6 mb-8 last:mb-0 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
    transitionDelay: `${index * 100}ms`
  }}>
      <div className="shrink-0 w-12 h-12 rounded-lg bg-card flex items-center justify-center shadow-sm border border-border">
        <Check className="w-6 h-6 text-primary" strokeWidth={3} />
      </div>
      <div className="flex flex-col pt-1">
        <h3 className="text-xl font-mono font-bold text-foreground mb-2">
          {feature.title}
        </h3>
        <p className="text-base font-normal text-muted-foreground leading-relaxed">
          {feature.description}
        </p>
      </div>
    </div>;
}
export default function WhyOperatorsChooseNeonGen() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="what-we-inspect" className="bg-muted py-24 lg:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-24">
          {}
          <div className="lg:col-span-5">
            <div ref={headerRef} className={`lg:sticky lg:top-32 transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <h2 className="text-4xl md:text-5xl font-display font-bold text-foreground tracking-tight leading-tight mb-6">
                Comprehensive Inspection Coverage
              </h2>
              <p className="text-lg text-muted-foreground mb-8 max-w-md">
                Our clinical approach to property assessment ensures every critical
                system is evaluated against the highest industry standards.
              </p>
              <Button size="lg" className="group bg-primary text-primary-foreground hover:bg-primary/90 rounded-lg">
                Book Your Inspection
                <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
              </Button>
            </div>
          </div>

          {}
          <div className="lg:col-span-7 flex flex-col pt-4 lg:pt-0">
            {features.map((feature, index) => <FeatureItem key={index} feature={feature} index={index} />)}
          </div>
        </div>
      </div>
    </section>;
}